import { mapState } from 'vuex'
import { plainToClass } from 'class-transformer'
import model from '@/models'
import Response from '@/utils/response'
import pageLoading from '@/mixins/page-loading'
import pageTitle from '@/mixins/page-title'
import InputWordsTable from '@/components/table/InputWordsTable'
import RadarChartWidget from '@/components/widget/RadarChartWidget'
import InputWordsTableController from '@/controllers/input-words-table-controller'

export default {
  components: {
    InputWordsTable,
    RadarChartWidget
  },
  mixins: [
    pageLoading,
    pageTitle,
  ],
  title () {
    return this.$t("pages.user.matchingships.show.title")
  },
  props: {
    repository: Object,
    id: Number
  },
  data () {
    return {
      matchingship: new model.Matchingship,
      pnChartData: {},
      faceChartData: {},
      answeredUsers: [],
      inputWordsTableController: new InputWordsTableController(this.repository)
    }
  },
  computed: {
    ...mapState([
      'previousRoute',
    ]),
    ...mapState('matching', [
      'bottomNav',
    ]),
    backRoute () {
      switch (this.previousRoute.name) {
        case 'matching-logs':
          return {
            name: 'matching-logs',
            params: { id: this.id },
          }
        case null:
          return { name: 'matching-index' }
        default:
          return 'back'
      }
    },
    navActions () {
      return {
        'answeredUsers': this.fetchAnsweredUsers,
        'inputWords': () => { this.$refs.inputWordsTable.onLoad() }
      }
    }
  },
  watch: {
    bottomNav (value) {
      if (!this.matchingship.isLoaded) return
      const action = this.navActions[value]
      if (action) action.call()
    }
  },
  created () {
    this.$store.commit('setFooter', false)
  },
  mounted () {
    this.fetchData()
    this.$store.commit('setBackRoute', this.backRoute)
  },
  beforeDestroy () {
    this.$store.commit('setFooter', true)
  },
  methods: {
    async fetchData () {
      if (this.loading) {
        return
      }
      this.loading = true

      try {
        const response = new Response(await this.repository.summary(this.id))
        this.matchingship = plainToClass(model.Matchingship, response.result)
        this.$store.commit('matching/setBottomNavInputWords', this.matchingship.showInputWords)
        this.$nextTick(() => {
          this.fetchPnChart()
          this.fetchFaceChart()
          const action = this.navActions[this.bottomNav]
          if (action) action.call()
        })
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    async fetchPnChart () {
      try {
        const response = new Response(await this.repository.pnChart(this.id))
        this.pnChartData = response.result
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      }
    },
    async fetchFaceChart () {
      try {
        const response = new Response(await this.repository.faceChart(this.id))
        this.faceChartData = response.result
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      }
    },
    fetchInputWords (searchParams = {}) {
      this.inputWordsTableController.fetch(
        this.id,
        searchParams
      ).catch(error => {pngeap
        this.$store.commit('setAxiosError', error)
      })
    },
    async fetchAnsweredUsers () {
      try {
        const response = new Response(await this.repository.answeredUsers(this.id))
        this.answeredUsers = plainToClass(model.User, response.result)
      } catch (error) {
        this.$store.commit('setAxiosError', error)
      }
    }
  }
}
